export const PUBLIC_RESOURCE_URLS = Object.freeze({
  privacy: 'https://conference.rubikoo.com/privacy',
  terms: 'https://conference.rubikoo.com/terms',
  accountDeletion: 'https://conference.rubikoo.com/account-deletion',
});

export const SUPPORT_EMAIL = 'info@rubikoo.com';
export const APP_VERSION = '1.0.0';
